import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

import type Sortable from 'sortablejs';
import fill from 'lodash/fill';
import { useDraggable } from 'vue-draggable-plus';
import { computed, provide, useCssModule, useTemplateRef } from 'vue';
import Item from '@/shared/legacy/ui/editable-list/item.vue';

type Props = {
  disabled?: boolean;
  value: {
    id: number;
    locked?: boolean;
    [key: string]: any;
  }[];
  moveHandler?: (e: Sortable.MoveEvent, originalEvent: Event) => void;
  ghostClass?: string;
  dragHandlerClass?: string;
  dragFilterClass?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'editable-list',
  props: {
    disabled: { type: Boolean },
    value: {},
    moveHandler: { type: Function },
    ghostClass: {},
    dragHandlerClass: { default: 'EDITABLE_LIST_DRAG_HANDLER_CLASS' },
    dragFilterClass: { default: 'DEFAULT_FILTER_CLASS' }
  },
  emits: ["update", "input", "drag:start", "drag:end"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

provide('$draggableDragHandlerClass', __props.dragHandlerClass);
provide('$draggableFilterClass', __props.dragFilterClass);

const onUpdate = (event: Sortable.SortableEvent) => {
  emit('update', event);
};
const onStart = (event: Sortable.SortableEvent) => {
  emit('drag:start', event);
};
const onEnd = (event: Sortable.SortableEvent) => {
  emit('drag:end', event);
};

const handleInput = (id: number, data: any, index: number) => {
  if (__props.disabled) {
    return;
  }
  const oldItem = __props.value[index];
  const newItem = {
    ...oldItem,
    data
  };
  const newValue = fill([...__props.value], newItem, index, index + 1);
  emit('input', newValue);
};
const handleRemove = (id: number) => {
  if (__props.disabled) {
    return;
  }
  emit(
    'input',
    __props.value.filter((item) => item.id !== id)
  );
};
const onMove = (e: Sortable.MoveEvent, originalEvent: Event) => {
  if (__props.disabled) {
    return;
  }
  if (e.related.children[0].dataset.orderable !== 'true') {
    return false;
  }
  if (__props.moveHandler) {
    return __props.moveHandler(e, originalEvent);
  }
};

const el = useTemplateRef<HTMLElement>('el');
const style = useCssModule();

const list = computed({
  get: () => __props.value,
  set: (newValue) => {
    emit('input', newValue);
  }
});

useDraggable(el, list, {
  animation: 150,
  ghostClass: __props.ghostClass || style.ghost,
  handle: `.${__props.dragHandlerClass}`,
  filter: `.${__props.dragFilterClass}`,
  preventOnFilter: false,
  onUpdate,
  onStart,
  onMove,
  onEnd
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-qa": "editableList",
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(__props.disabled && _ctx.$style.disabled)
    }, [
      _createElementVNode("ul", {
        ref_key: "el",
        ref: el,
        class: _normalizeClass(_ctx.$style.container)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id
          }, [
            _renderSlot(_ctx.$slots, "item", {
              item: item,
              defaultItemClass: _ctx.$style.item,
              handleInput: handleInput,
              index: index
            }, () => [
              (list.value.find(e => e.id === item.id))
                ? (_openBlock(), _createBlock(Item, _mergeProps({
                    key: 0,
                    ref_for: true
                  }, item, {
                    id: item.id,
                    index: index,
                    class: _ctx.$style.item,
                    onInput: ($event: any) => (handleInput(item.id, $event, index)),
                    onRemove: handleRemove
                  }), null, 16, ["id", "index", "class", "onInput"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        _createElementVNode("li", {
          class: _normalizeClass(_ctx.$style.footer)
        }, [
          _renderSlot(_ctx.$slots, "append")
        ], 2)
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.controls)
    }, [
      _renderSlot(_ctx.$slots, "controls")
    ], 2)
  ], 2))
}
}

})